/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StammdatenInputs */



/**

* @param {_Field_StammdatenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_stammdaten = /** @type {((inputs?: _Field_StammdatenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StammdatenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Stammdaten")
});